// extracted by mini-css-extract-plugin
export default {"wrapper":"Placeholder_wrapper__hFPJ4","short":"Placeholder_short__NGs5R","progressWrapper":"Placeholder_progressWrapper__HwiAs","button":"Placeholder_button__s13Vb"};